"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var ProcessTransition = /** @class */ (function () {
    function ProcessTransition() {
        var _a;
        this.elements = document.querySelectorAll("[".concat(constants_1.DATA_PROCESS_TRANSITION, "]"));
        if (!this.elements)
            return;
        var winHeight = window.innerHeight;
        (_a = this.elements) === null || _a === void 0 ? void 0 : _a.forEach(function (element) {
            var elHeight = element.offsetHeight;
            var textMoveLeft = element === null || element === void 0 ? void 0 : element.querySelector("[".concat(constants_1.DATA_PROCESS_TRANSITION_LEFT, "]"));
            var textMoveRight = element === null || element === void 0 ? void 0 : element.querySelector("[".concat(constants_1.DATA_PROCESS_TRANSITION_RIGHT, "]"));
            document === null || document === void 0 ? void 0 : document.addEventListener('scroll', function () {
                var top = element === null || element === void 0 ? void 0 : element.getBoundingClientRect().top;
                var position = Math.round((top - winHeight + .5 * elHeight) * 1.2);
                window === null || window === void 0 ? void 0 : window.requestAnimationFrame(function () {
                    if (textMoveLeft && position)
                        textMoveLeft.style.transform = "translateX(".concat(position, "px) translateZ(0)");
                    if (textMoveRight && position)
                        textMoveRight.style.transform = "translateX(".concat(position * -1, "px) translateZ(0)");
                });
            });
        });
    }
    return ProcessTransition;
}());
exports.default = ProcessTransition;
